module.exports = __webpack_public_path__ + "img/twitter-icon.e5e73c48.png";